import { FunctionComponent, useEffect, useState } from 'react'
import DashboardItem from '../DashboardItem'
import { useTranslation } from 'react-i18next'
import { getAllHiddenWorkrooms } from 'Frontend/scripts/services/workrooms.service'
import { IWorkroomExtended } from 'Frontend/scripts/models/workrooms.model'
import HiddenWorkroom from './HiddenWorkroom'

const HiddenWorkrooms: FunctionComponent = () => {
  const [hiddenWorkrooms, setHiddenWorkrooms] = useState<IWorkroomExtended[]>([])
  const { t } = useTranslation()

  useEffect(() => {
    getAllHiddenWorkrooms().then((hiddenWorkrooms) => {
      setHiddenWorkrooms(hiddenWorkrooms)
    })
  }, [])

  if (!hiddenWorkrooms) return <></>

  return (
    <DashboardItem heading={t('hidden-workrooms')}>
      <ul className="list-unstyled d-flex flex-column">
        {hiddenWorkrooms && hiddenWorkrooms?.length > 0 ? (
          <>
            {hiddenWorkrooms.map((workroom) => (
              <HiddenWorkroom workroom={workroom} key={`hidden-workroom-${workroom.id}`} />
            ))}
          </>
        ) : (
          <span>{t('no-hidden-workrooms')}</span>
        )}
      </ul>
    </DashboardItem>
  )
}

export default HiddenWorkrooms
